import classnames from "classnames";
import { ErrorMessage } from "formik";
import { MdErrorOutline } from "react-icons/md";

/* eslint-disable react/prop-types */
const TextArea = ({
  type = "text",
  title,
  name,
  placeholder,
  requiredField,
  errors = {},
  values = {},
  touched = {},
  handleChange = () => {},
  handleBlur = () => {},
  extraDetails = "",
}) => {
  const hasError = errors?.[name] && touched?.[name];
  const value = values?.[name] ?? "";

  return (
    <div className="mb-4">
      <label
        htmlFor={name}
        className="block leading-6 text-gray-500 mb-1 text-sm"
      >
        {title}
        {requiredField && <span className="text-red-800 mx-1">*</span>}
      </label>

      {extraDetails && (
        <p className="leading-6 text-gray-500 text-xs my-1">{extraDetails}</p>
      )}

      <textarea
        id={name}
        name={name}
        type={type}
        rows={3}
        onChange={handleChange(name)}
        onBlur={handleBlur(name)}
        value={value}
        placeholder={placeholder}
        className={classnames(
          "block w-full rounded-md border-0 py-2 px-3 text-gray-500 ring-1 ring-inset placeholder:text-gray-400 placeholder:font-light focus:ring-1 focus:ring-inset sm:text-sm sm:leading-6 focus:outline-none",
          hasError
            ? "ring-red-600 focus:ring-red-600 text-red-600"
            : "ring-gray-300 focus:ring-primary-dark"
        )}
      ></textarea>

      {hasError && (
        <div className="text-xs text-red-500 text-left w-full flex gap-1 items-center mt-1">
          <MdErrorOutline size={16} />
          <p className="text-xs">{errors[name]}</p>
        </div>
      )}
    </div>
  );
};

export default TextArea;
